import React, { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { auth.getUser().then((r) => setUser(r.data.user)).catch(() => setUser(null)).finally(() => setLoading(false)); }, []);
  const logout = async () => { try { await auth.logout(); } catch (_) { /* */ } setUser(null); window.location.href = "/login"; };
  return <AuthContext.Provider value={{ user, loading, logout, isAdmin: user?.role === "admin", canManage: user?.role === "admin" || user?.role === "manager" }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
